class TesterUsageReportController {
    constructor(moment, ngProgressFactory, ReportUtils, ReportServiceApi, SettingsService, toastr) {
        this.$onInit = () => {
            this.ngProgress = this.ngProgressFactory.createInstance();
            this.data = {
                availableTimeframes: [
                    { key: 'Last 7 Days', value: TesterUsageReportTimeframe.SevenDays },
                    { key: 'Last 30 Days', value: TesterUsageReportTimeframe.ThirtyDays },
                    { key: 'All Time', value: TesterUsageReportTimeframe.AllTime }
                ]
            };
            this.state = {
                showReport: false,
                selectedTimeframe: this.data.availableTimeframes[0],
                usageReport: null,
                dateFormat: '',
                totalMessages: 0
            };
            this.columnDefs = [
                {
                    headerName: 'User ID',
                    field: 'UserId',
                    width: 30
                },
                {
                    headerName: 'Username',
                    field: 'UserName',
                    minWidth: 90
                },
                {
                    headerName: 'Message Count',
                    field: 'MessageCount',
                    minWidth: 90
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.SettingsService.getSettings().then((response) => {
                this.state.dateFormat = response.data.DateFormat;
                this.state.showReport = true;
                this.onSelectTimeframe(this.state.selectedTimeframe.value);
            });
        };
        this.startLoading = () => {
            this.ngProgress.start();
            if (!_.isNil(this.gridOptions.api)) {
                this.gridOptions.api.showLoadingOverlay();
            }
        };
        this.endLoading = () => {
            this.ngProgress.complete();
            if (!_.isNil(this.gridOptions.api)) {
                this.gridOptions.api.hideOverlay();
            }
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.onModelUpdated = () => {
            if (this.state.usageReport) {
                this.state.totalMessages = this.state.usageReport.Items.reduce((total, item) => total + item.MessageCount, 0);
            }
        };
        this.addDateToTitle = (title) => {
            const ydm = this.moment().format('YYYYDDMM');
            const hhmm = this.moment().format('hhmm');
            const reportName = [ydm, ' ', hhmm, ' ', title].join('');
            return reportName;
        };
        this.exportCsv = () => {
            const title = 'TesterUsageReport.csv';
            const reportName = this.addDateToTitle(title);
            const params = {
                allColumns: false,
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.getTimezoneOffset = () => {
            let currentDate = new Date();
            let timezoneOffset = currentDate.getTimezoneOffset();
            return timezoneOffset;
        };
        this.toFormattedDateTime = (dateTime) => {
            if (_.isNil(dateTime)) {
                return '';
            }
            return this.moment.utc(dateTime).format(this.state.dateFormat);
        };
        this.refreshOnServer = () => {
            this.startLoading();
            this.ReportServiceApi.refreshTesterUsageTotals()
                .then((response) => {
                this.endLoading();
                if (response.data) {
                    this.onSelectTimeframe(this.state.selectedTimeframe.value);
                }
                else {
                    this.toastr.error('Error refreshing totals. Ensure the SQL Agent job and stored procedure have been setup correctly.');
                }
            });
        };
        this.moment = moment;
        this.ngProgressFactory = ngProgressFactory;
        this.ReportUtils = ReportUtils;
        this.ReportServiceApi = ReportServiceApi;
        this.SettingsService = SettingsService;
        this.toastr = toastr;
    }
    onSelectTimeframe(timeframe) {
        this.startLoading();
        this.ReportServiceApi.getTesterUsageReport(timeframe, this.getTimezoneOffset())
            .then((response) => {
            this.state.usageReport = response.data;
            this.gridOptions.api.setRowData(this.state.usageReport.Items);
            this.endLoading();
        });
    }
}
angular.module('app').component('testerUsageReport', {
    templateUrl: 'Scripts/App/partials/Reports/tester-usage-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: TesterUsageReportController
});
